<template>
  <div class="warp warp_enterprise" v-if="data">
    <Head></Head>
    <div class="modle_1" :style="'background: url('+data.img2+') center no-repeat;'">
      <div class="txt_box">
        <div class="t1">

          {{data.encatname}}
        </div>
        <div class="t2">
          {{data.catname}}
        </div>
        <div class="t3">

          {{data.seodescription}}
        </div>
      </div>
      <ChildBan></ChildBan>
    </div>


    <div class="modle_7">

      <div class="cm_title">

        <div class="t1" v-scroll-reveal>
          CREATIVE CASE
        </div>

        <div class="t2" v-scroll-reveal>
          创意案例
        </div>

      </div>

      <div class="tabbar">
        <!-- it_on -->
        <span class="it" v-scroll-reveal @click="sle_int = index" :class="sle_int == index ? 'it_on' : ''"
          v-for="(item,index) in data.list" :key="index">
          {{item.catname}}
        </span>

      </div>

      <div class="groups cle">
        <div class="masonry">
          <div class="item" v-scroll-reveal v-for="(item,index) in data.list[sle_int].list" @click="opendialogTableVisible(item)">
            <!-- {{data.list[sle_int].list}} -->
            <img :src="item.img1" />

          </div>



        </div>
        <div style="text-align: center; margin-bottom: 30px;" v-if="data.list[sle_int].list.length == 0">
          暂无数据~
        </div>

      </div>

      <div class="modle_8" v-if="jzdata">
        <div class="cm_title">
          <div class="t1" v-scroll-reveal>
            PRECISE DELIVERY
          </div>
          <div class="t2" v-scroll-reveal>
            精准投放
          </div>
        </div>

        <div class="_img" v-scroll-reveal>

          <img :src="jzdata.img1" style="width: 100%;" />
        </div>

        <div class="group cle">

          <div class="fl item" v-scroll-reveal v-for="(item,index) in jzdata.list">

            <div class="img">
              <img :src="item.img1" style="width: 100%;" />
            </div>
            <div class="tit txtov">
              {{item.title}}
            </div>

          </div>

        </div>


      </div>


      <div class="modle_8" v-if="fwdata">
        <div class="cm_title">
          <div class="t1" v-scroll-reveal>
            DIGITAL MARKETING
          </div>
          <div class="t2" v-scroll-reveal>
            数据化营销
          </div>
        </div>

        <div class="_img" v-scroll-reveal>

          <img :src="fwdata.img1" style="width: 100%;" />
        </div>

        <div class="group cle">

          <div class="fl item" v-scroll-reveal v-for="(item,index) in fwdata.list">

            <div class="img" v-scroll-reveal>
              <img :src="item.img1" style="width: 100%;" />
            </div>
            <div class="tit txtov" v-scroll-reveal>
              {{item.title}}
            </div>

          </div>

        </div>


      </div>

      <div class="modle_8" v-if="fwnrdata">
        <div class="cm_title">
          <div class="t1" v-scroll-reveal>
         Marketing & Planning
          </div>
          <div class="t2" v-scroll-reveal>
           营销策划
          </div>
        </div>

        <div class="_img" v-scroll-reveal>

          <img :src="fwnrdata.img1" style="width: 100%;" />
        </div>

        <div class="group cle">

          <div class="fl item" v-scroll-reveal v-for="(item,index) in fwnrdata.list">

            <div class="img" v-scroll-reveal>
              <img :src="item.img1" style="width: 100%;" />
            </div>
            <div class="tit txtov" v-scroll-reveal>
              {{item.title}}
            </div>

          </div>

        </div>


      </div>



    </div>


    <!-- 弹出层 -->
    <div class="boxsboxs" v-if="dialogTableVisible">
      <div class="zz" @click="dialogTableVisible = false" ></div>
      <div class="dm">
        <img :src="sel_open_img.img1" style="width: 100%;" />
        <div class="clis" style="margin-top: 10px;">
           <el-button type="success"  @click="dialogTableVisible = false" >关闭</el-button>
        </div>
      </div>

    </div>



  </div>
</template>

<script>
  import {
    postCasesAPI,
    postfwtfAPI,
    postfwjsAPI,
    postfwnrAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'

  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        sle_int: 0, //下表
        data: null, //案例信息
        jzdata: null, //精准投放
        fwdata: null, //服务案例
        dialogTableVisible: false,
        sel_open_img: '', //图片地址
        clickopen: false,
        fwnrdata:null,//服务内容

      }
    },
    methods: {
      //获取案例信息
      getList() {
        var that = this;
        postCasesAPI().then(function(res) {
          console.log(res);
          that.data = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })
      },
      //精准投放
      jingzhunGetList() {
        var that = this;
        postfwtfAPI().then(function(res) {
          console.log(res);
          that.fwdata = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })
      },
      //服务案例
      fuwuanliGetList() {
        var that = this;
        postfwjsAPI().then(function(res) {
          console.log(res);
          that.jzdata = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })
      },
      //服务内容
      fuwuneirongGetlist(){
        var that = this;
        postfwnrAPI().then(function(res) {
          console.log(res);
          that.fwnrdata = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })

      },
      //打开
      opendialogTableVisible(row) {
        console.log(row);
        var that = this;
        this.dialogTableVisible = true;
        this.sel_open_img = row;

      },
    },
    mounted() {
      this.getList();
      this.jingzhunGetList();
      this.fuwuanliGetList();
      this.fuwuneirongGetlist();
    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }

  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
  }

  .boxsboxs {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 9999;

    .zz {
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      background: rgba(0, 0, 0, 0.5);
    }

    .dm {
      position: fixed;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 90%;
      left: 50%;
      max-width: 800px;
      width: 80%;
      background: #fff;
      border-radius: 10px;
      padding: 10px;
      overflow-y: scroll;
    }
  }

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }


  .modle_7 {
    margin: 0px 135px;
    margin-top: 160px;

    .cm_title {
      text-align: center;
      margin-bottom: 125px;

      .t1 {
        font-size: 93px;
        color: #000000;
        font-weight: bold;
        margin-bottom: 40px;
      }

      .t2 {
        font-size: 50px;
        color: #000000;
        letter-spacing: 15px;
      }
    }

    .tabbar {
      text-align: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
      margin-bottom: 130px;
      padding-bottom: 30px;
      margin-bottom: 100px;

      .it {
        font-size: 20px;
        color: #636363;
        width: 14%;
        display: inline-block;
        text-align: center;
        cursor: pointer;
      }

      .it_on {
        font-weight: bold;
        color: #000000;
        font-size: 26px;
      }
    }
  }

  .masonry {
    column-count: 3;
    column-gap: 5px;

    .item {
      break-inside: avoid;
      box-sizing: border-box;

      margin-bottom: 7px;

      display: flex;
      align-items: center;
      justify-content: center;


      color: brown;
      border: 0px none !important;
    }
  }


  .modle_8 {
    // margin-top: -20%;
    margin-top: 150px;

    .cm_title {
      margin-bottom: 80px;
    }

    ._img {
      margin-bottom: 30px;
    }

    .group {
      .item {
        width: 48%;
        margin-bottom: 20px;

        .tit {
          font-size: 25px;
          margin-top: 15px;
        }
      }

      .item:nth-child(2n) {
        float: right;
      }
    }
  }

  .warp_enterprise {
    padding-bottom: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/view/case/case.vue